import React from "react";

import { css } from "@emotion/css";
import { Link, ToOptions } from "@tanstack/react-router";

import { FontSizes } from "@/assets/fonts.ts";
import { IconType } from "@/assets/icons.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { TextTooltip } from "@/uiKit/atoms/Tooltip.tsx";
import { Required } from "@/utils/commonUtils.ts";

/**
 * TODO STE-1602 remove isCurrent
 * it should be handled automatically by tanstack router
 */
export type NavigationItemProps = {
  id: string;
  "data-action": string;
  Icon: IconType;
  isCurrent?: boolean;
  tooltip?: string;
} & Required<ToOptions, "to">;

export const NavigationItem: React.FC<NavigationItemProps> = ({
  id,
  Icon,
  tooltip,
  "data-action": dataAction,
  isCurrent = false,
  ...toOptions
}) => {
  const styles = useStyles(makeStyles, isCurrent);
  return (
    <Link data-action={dataAction} id={id} {...toOptions}>
      <TextTooltip popupId={`${id}-tooltip`} text={tooltip} placement="right">
        <div className={styles.container}>
          <Icon className={styles.icon} />
        </div>
      </TextTooltip>
    </Link>
  );
};

const makeStyles = (theme: Theme, isCurrent: boolean) => ({
  container: css`
    display: flex;
    aspect-ratio: 1/1;
    justify-content: center;
    align-items: center;
    margin: ${theme.spacing(4)} 0;
    padding: calc(${theme.spacing(12)} / 2);
    border-radius: ${theme.spacing(8)};
    background-color: ${isCurrent ? theme.palette.primary.main : theme.palette.common.white};
  `,
  icon: css({
    cursor: "pointer",
    fill: isCurrent ? theme.palette.common.white : theme.palette.primary.main,
    width: FontSizes.h6,
    height: FontSizes.h6,
  }),
});
